import { z } from 'zod';
import { VENDOR_CONSTRAINTS as LIMITS } from './constraints.js';
/** New Vendor's duplicate-name check: the name as typed so far. */
export const vendorNameMatchArgsSchema = z.object({
    name: z.string().trim().min(1, `${LIMITS.name.label} is required.`).max(LIMITS.name.maxLength),
});
//# sourceMappingURL=name-match-args.js.map